
// // 引入
// import jsrsasign from 'jsrsasign'
// const RSA_PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJbM+f1/Wjti4Z7QP29hhw9cqNsiAerQl7D+vSccyZUBYQFNXQwLXnov9/aFWYHCkQglCgfXWVq7Ka2DMOlgYDw5cQwXYiOm1+3QFQw0woDsYUlg4wr/nWHCkhWudUtbxfEL3w0GTTl0+VpiSfEkXkfBO53fBHhtI/RT/kb59/8wIDAQAB'
// function install (Vue) {
//   // 公共方法挂载
//   Vue.prototype.$rsa = (text) => {
//     let pk = '-----BEGIN PUBLIC KEY-----' + RSA_PUBLIC_KEY + '-----END PUBLIC KEY-----'
//     let pub = jsrsasign.KEYUTIL.getKey(pk)
//     let enc = jsrsasign.KJUR.crypto.Cipher.encrypt(text, pub)
//     enc = jsrsasign.hextob64(enc)
//     return enc
//   }
// }
//
// export default install
import JSEncrypt from './jsencrypt.min'
// const RSA_PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC3tv94ertpW1LejYc1KCmCr+xWh3W58DjlzZi4LlTczk38hq/31618GevmDzXOgH8SZcKIQsQ7plPeK4dV2PXQUKpmXV5NHwn2qhB0EtnPDhRLSdh4c0RWbUorEM+Og2BncP2KLCoHS1nyuKwtBltfRHGhQ1/siZ0h00V8vzpo+QIDAQAB'
const RSA_PUBLIC_KEY =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJbM+f1/Wjti4Z7QP29hhw9cqNsiAerQl7D+vSccyZUBYQFNXQwLXnov9/aFWYHCkQglCgfXWVq7Ka2DMOlgYDw5cQwXYiOm1+3QFQw0woDsYUlg4wr/nWHCkhWudUtbxfEL3w0GTTl0+VpiSfEkXkfBO53fBHhtI/RT/kb59/8wIDAQAB'
const RSA = new JSEncrypt()
RSA.setPublicKey(RSA_PUBLIC_KEY)
function install(Vue) {
  Vue.prototype.$rsa = (text) => {
    return RSA.encrypt(text)
  }
}
export default install
